import { useCallback } from "react";
import { navigate } from "wouter/use-location";

import { useUrl } from "./hooks/useUrl";

export const useHashState = (key: HashtagString): HashStateHookResult => {
  const { hash } = useUrl();

  const next = useCallback(
    (nextKey?: HashtagString): void => {
      const nextHash = nextKey || "";
      const { pathname, search } = window.location;
      const nextLocation = `${pathname}${search}${nextHash}`;
      navigate(nextLocation, { replace: true });
    },
    [hash]
  );

  const actions: HashStateHookActions = {
    hide: useCallback(() => next(), [next]),
    show: useCallback(() => next(key), [next]),
  };

  return [hash === key, actions];
};

export const createHashStateHook =
  (panelName: HashtagString) =>
  (currentPanelName: HashtagString = panelName): HashStateHookResult =>
    useHashState(currentPanelName);

export type HashtagString = `${"#"}${string}`;

type HashStateHookActions = {
  hide(): void;
  show(): void;
};

export type HashStateHookResult = [boolean, HashStateHookActions];
